import React, { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from '@mui/material';
import { SearchOutlined } from '@mui/icons-material';

const apiKey = 'AIzaSyBzeoM-0mE5KeB-yVLccC7Wc03YnZGd1-s';
const mapApiJs = 'https://maps.googleapis.com/maps/api/js';

function loadAsyncScript(src: string) {
  return new Promise((resolve) => {
    const script = document.createElement('script');
    Object.assign(script, {
      type: 'text/javascript',
      async: true,
      src,
    });
    script.addEventListener('load', () => resolve(script));
    document.head.appendChild(script);
  });
}

function GoogleAutoCompleteInput() {
  const searchInput = useRef<HTMLInputElement>();
  const query = new URLSearchParams(useLocation().search);
  const queryPage = query.get('city');
  const history = useHistory();
  const location = useLocation();
  const initMapScript = () => {
    if (window.google) {
      return Promise.resolve();
    }
    const src = `${mapApiJs}?key=${apiKey}&libraries=places&v=weekly&language=en`;
    return loadAsyncScript(src);
  };
  const onChangeAddress = (autocomplete: any) => {
    const place = autocomplete.getPlace();
    if (place.address_components) {
      const currentCity = place.address_components[0].long_name;
      const params = new URLSearchParams({ city: currentCity });
      history.replace({
        pathname: location.pathname,
        search: params.toString(),
      });
    } else {
      history.replace({
        pathname: location.pathname,
        search: '',
      });
    }
  };
  const initAutocomplete = () => {
    if (!searchInput.current) return;
    const autocomplete = new window.google.maps.places.Autocomplete(
      searchInput.current,
      { types: ['(cities)'] },
    );
    autocomplete.setFields(['address_component', 'geometry']);
    autocomplete.addListener('place_changed', () =>
      onChangeAddress(autocomplete),
    );
  };

  useEffect(() => {
    initMapScript().then(() => {
      initAutocomplete();
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <FormControl
      sx={{
        position: 'sticky',
        top: '110px',
        width: '40vw',
        background: 'white',
      }}
      variant="outlined"
    >
      <InputLabel htmlFor="outlined-adornment-password">city</InputLabel>
      <OutlinedInput
        id="outlined-adornment-password"
        type="text"
        placeholder="Type something"
        inputRef={searchInput}
        defaultValue={queryPage || ''}
        aria-describedby="component-text"
        sx={{
          background: 'white',
        }}
        endAdornment={
          <InputAdornment position="end">
            <IconButton aria-label="visibility" edge="end">
              <SearchOutlined />
            </IconButton>
          </InputAdornment>
        }
        label="city"
      />
    </FormControl>
  );
}

export default GoogleAutoCompleteInput;
